module.exports = __webpack_public_path__ + "static/img/beijing.1784015206260.png";